import {useEffect, useState} from 'react';
import {Skeleton} from '@mui/material';
import {EntityActivitiesRepository} from '../../../repositories/entity-activities';
import {useParams} from 'react-router-dom';
import {CarePlanConfiguration} from '../../../backend/interfaces/care-plan-configuration';
import {scheduleReadableExpression} from '../../../utils/functions';
import {useTranslation} from 'react-i18next';
import {PeriodOfTheDayItem} from '../../../types';

interface PosologyScheduleCardValueProps {
  activitiesSectorId: string;
  activitiesGroupId: string;
  configuration: CarePlanConfiguration;
  itemId: string;
}

export const PosologyScheduleCardValue = ({
  activitiesSectorId,
  activitiesGroupId,
  configuration,
  itemId,
}: PosologyScheduleCardValueProps) => {
  const {t} = useTranslation();
  const {entityId} = useParams<{entityId: string}>();
  const [period, setPeriod] = useState<string[]>([]);

  useEffect(() => {
    const fetchType = async () => {
      const schedule = JSON.parse(String(itemId));
      schedule?.periodsOfTheDay?.map(async (period: PeriodOfTheDayItem) => {
        const type = await EntityActivitiesRepository.instance.getType(
          entityId,
          activitiesSectorId,
          activitiesGroupId,
          period.activityTypeId
        );
        setPeriod((prev) => [...prev, `${type?.name} - ${period.quantity}`]);
      });
    };
    fetchType();
  }, [activitiesGroupId, activitiesSectorId, entityId, itemId]);

  if (!period) {
    return (
      <Skeleton
        animation="wave"
        variant="rectangular"
        sx={{
          height: '20px',
          width: '50%',
          borderRadius: '10px',
        }}
      />
    );
  }

  return (
    <div>
      <label className="title">{configuration?.name}</label>
      <div className="period">
        {period.map((p, index) => {
          return (
            <div key={`period-${index}`} className="value">
              {p}
            </div>
          );
        })}
      </div>
      <div className="value">
        {scheduleReadableExpression({
          t,
          scheduleDefinition: JSON.parse(String(itemId)),
          hidePrefix: true,
        })}
      </div>
    </div>
  );
};
